import SvgIcon from "@/components/common/SvgIcon";
import { Typography } from "@/components/kit";
import useBreadcrumbs from "@/hooks/store/useBreadcrumbs";
import {
  Popover,
  PopoverContent,
  PopoverHandler,
} from "@material-tailwind/react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { showArticle } from "@intercom/messenger-js-sdk";

type TRoutes = {
  path?: string;
  name: string;
  description?: string;
  helpLink?: string;
  search?: string;
  onClick?: () => void;
};
export type TBreadCrumbListProps = {
  routes: TRoutes[];
  onBack: () => void;
};
export const BreadCrumbList = ({ routes }: TBreadCrumbListProps) => {
  const { t } = useTranslation();
  return (
    <ol className="list-none p-0 inline-flex items-baseline gap-2">
      {/* <SvgIcon
        className={classNames("cursor-pointer hidden", {
          "!block": routes.length > 1,
        })}
        onClick={onBack}
        iconName="chevronLeft"
      /> */}
      {routes.map((route, index) => {
        return (
          <li key={index} className="flex items-center gap-1">
            <Typography
              variant={
                index !== routes.length - 1 ? "Body2-Regular" : "Body2-Bold"
              }
              color={
                index !== routes.length - 1 ? "text-gray-500" : "text-gray-800"
              }
              onClick={route.onClick}
              className={classNames("!text-gray-700 capitalize", {
                "cursor-pointer": route.onClick,
              })}
            >
              {route.name}
              {index !== routes.length - 1 && `  >`}
            </Typography>
            {(route.description || route.helpLink) && (
              <Popover placement="bottom-start">
                <PopoverHandler>
                  <div>
                    <SvgIcon
                      className="p-0 h-4 w-4 !fill-blue-600 cursor-pointer"
                      iconName="info"
                    />
                  </div>
                </PopoverHandler>
                <PopoverContent
                  placeholder=""
                  className="dark:bg-blue-gray-800 border-0 !z-[9999] "
                >
                  <div className="w-[350px] flex flex-col gap-1">
                    <Typography
                      className="leading-[24px]"
                      color="text-gray-600"
                      variant="Body2-Regular"
                    >
                      {route.description}{" "}
                      {route.helpLink && (
                        <div
                          onClick={() => {
                            const articleNumber = +(
                              route?.helpLink
                                ?.split("/")
                                ?.reverse()[0]
                                ?.split("-")?.[0] || 0
                            );
                            if (articleNumber) {
                              showArticle(articleNumber.toString());
                            }
                          }}
                          className="cursor-pointer"
                        >
                          <Typography
                            color="text-blue-600"
                            variant="Body2-Regular"
                          >
                            {t("learn_more")}
                          </Typography>
                        </div>
                      )}
                    </Typography>
                  </div>
                </PopoverContent>
              </Popover>
            )}
          </li>
        );
      })}
    </ol>
  );
};

const Breadcrumb = () => {
  const { routes: pureRoutes } = useBreadcrumbs();

  const navigate = useNavigate();
  const routes = pureRoutes.map((route) => ({
    ...route,
    ...(route.path && {
      onClick: () => navigate(route.path as string),
    }),
  }));

  return (
    <nav className="text-sm font-medium flex items-center">
      <BreadCrumbList routes={routes} onBack={() => navigate(-1)} />
    </nav>
  );
};

export default Breadcrumb;
